import { Component, OnInit, OnDestroy } from '@angular/core';
import { DRUG_TOGGLE_OPTIONS } from 'src/app/shared/enums/drug-costs.enum';
import { MatRadioChange } from '@angular/material/radio';
import { StateStructure } from '@ptl/state';
import { NgRedux, select } from '@ptl/angular-redux-store';
import { toggleMailOrderOrRetail, DRXStateStructure } from '../../medication-information/reducers/drx-response.reducer';
import { Observable, Subscription } from 'rxjs';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { DRXMonthlyCosts } from '../../../../shared/interfaces/drx.interface';

@Component({
    selector: 'app-toggle-radio',
    templateUrl: './toggle-radio.component.html',
    styleUrls: ['./toggle-radio.component.scss'],
    standalone: false
})
export class ToggleRadioComponent implements OnInit {

  retailMailOrderSwitch: DRUG_TOGGLE_OPTIONS = DRUG_TOGGLE_OPTIONS.RETAIL;
  hasMailCosts: boolean = true;
  
  @select(['componentStates', 'DrxServiceData', 'drxMonthlyCosts', 'mailOrder'])
  mailOrder$: Observable<DRXMonthlyCosts>;

  options = [{
    value: DRUG_TOGGLE_OPTIONS.RETAIL,
    label: 'Retail'
  }, {
    value: DRUG_TOGGLE_OPTIONS.MAIL_ORDER,
    label: 'Mail Order'
  }];

  constructor(
    private ngRedux: NgRedux<StateStructure>,
    private reducerUtilityService: ReducerUtilityService
  ) {
  }

  updateSelection(event: MatRadioChange) {
    this.ngRedux.dispatch(toggleMailOrderOrRetail(event.value));
  }

  ngOnInit() {
    const drxServiceData = this.reducerUtilityService.getState('DrxServiceData') as DRXStateStructure;
    this.retailMailOrderSwitch = drxServiceData.drxToggleOption;

    this.mailOrder$.subscribe((val) => {
      if (val) {
        this.hasMailCosts = true;
      }
      else {
        this.hasMailCosts = false;
        this.retailMailOrderSwitch = DRUG_TOGGLE_OPTIONS.RETAIL;
        this.ngRedux.dispatch(toggleMailOrderOrRetail(this.retailMailOrderSwitch));
      }
    });
  }

}
